import { render } from "./Header.vue?vue&type=template&id=0c0ca1c8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=0c0ca1c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c0ca1c8"

export default script